// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".enterprise-text-section--s2ehQ{color:#fff;background-color:#5645f5}.enterprise-text-section--s2ehQ .btn.lumen5-button.btn-primary{background:#fff;color:#5645f5}.enterprise-text-section-image--eTVnB{border-radius:10px;overflow:hidden;max-width:80%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"enterprise-text-section": "enterprise-text-section--s2ehQ",
	"enterprise-text-section-image": "enterprise-text-section-image--eTVnB"
};
export default ___CSS_LOADER_EXPORT___;
